import { headerBreak } from '@/components/content/Header/styles/break';
import { SxProps, Theme } from '@mui/material';

export const myRecentOrdersHeaderSX = (theme: Theme, isSelected: boolean): SxProps => ({
	display: 'flex',
	zIndex: 5000,
	cursor: 'pointer',
	borderRadius: '3px',
	minWidth: '50px',
	padding: '10px',
	height: '44px',
	justifyContent: 'center',
	...(isSelected && { backgroundColor: 'grey.50' }),
	'& svg': {
		color: isSelected ? 'primary.main' : 'grey.500',
	},
	'&:hover': {
		backgroundColor: 'grey.50',
		'& svg': {
			color: 'primary.main',
		},
	},
});

export const headerMyRecentOrderMobileContainerSX = (theme: Theme): SxProps => ({
	zIndex: 1,
	display: 'flex',
	' > p': {
		paddingTop: '1px',
		paddingLeft: '3px',
	},
	' > span': {
		opacity: 1,
	},
	[theme.breakpoints.up('lg')]: {
		flexDirection: 'column',
		gap: '2px',
		alignItems: 'center',
		height: '44px',
		justifyContent: 'center',
	},
	[theme.breakpoints.down('lg')]: {
		gap: '10px',
		alignItems: 'center',
	},
});

export const myRecentOrdersHeaderIconSX = (theme: Theme): SxProps => ({
	marginLeft: '2px',
	zIndex: 3000,
	height: '24px',
	[theme.breakpoints.up('lg')]: {
		paddingTop: '2px',
	},
});

export const myRecentOrdersHeaderLabelSX = (theme: Theme): SxProps => ({
	zIndex: 3000,
	display: headerBreak({ xs: 'none', mobile: 'none', desktop: 'block' }),
	textAlign: 'center',
	color: 'grey.500',
	[theme.breakpoints.up('md')]: {
		display: 'block',
		fontSize: '15px',
	},
	[theme.breakpoints.up('lg')]: {
		fontSize: '12px',
	},
});
